var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectionRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_3293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3 15.0069C16.5813 15.2882 16.9628 15.4461 17.3605 15.4461C17.7582 15.4461 18.1397 15.2882 18.421 15.0069L23.147 10.2819C23.6959 9.73189 24.0042 8.98654 24.0042 8.20944C24.0042 7.43235 23.6959 6.687 23.147 6.13694L18.416 1.41194C18.2795 1.26099 18.1138 1.13938 17.9288 1.05452C17.7439 0.969651 17.5436 0.923306 17.3402 0.918301C17.1367 0.913295 16.9344 0.949735 16.7455 1.0254C16.5566 1.10107 16.3851 1.21438 16.2414 1.35844C16.0976 1.5025 15.9847 1.6743 15.9095 1.86338C15.8343 2.05246 15.7983 2.25486 15.8038 2.45828C15.8093 2.6617 15.8561 2.86187 15.9414 3.04662C16.0267 3.23138 16.1487 3.39684 16.3 3.53294L19.532 6.69994H5.319C3.90888 6.7018 2.55705 7.26278 1.55994 8.25989C0.56284 9.25699 0.00185211 10.6088 0 12.0189L0 18.6999C0.00158806 20.1099 0.562386 21.4616 1.55936 22.4586C2.55633 23.4556 3.90807 24.0164 5.318 24.0179H18.682C19.0798 24.0179 19.4614 23.8599 19.7427 23.5786C20.024 23.2973 20.182 22.9158 20.182 22.5179C20.182 22.1201 20.024 21.7386 19.7427 21.4573C19.4614 21.176 19.0798 21.0179 18.682 21.0179H5.318C4.70347 21.0172 4.11434 20.7727 3.6798 20.3381C3.24527 19.9036 3.00079 19.3145 3 18.6999V12.0189C3.00053 11.4041 3.24502 10.8145 3.6798 10.3797C4.11459 9.94497 4.70413 9.70047 5.319 9.69994H19.478L16.3 12.8859C16.0188 13.1672 15.8608 13.5487 15.8608 13.9464C15.8608 14.3442 16.0188 14.7257 16.3 15.0069Z",
    fill: "#e64d4a"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_3293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionRed);
export default __webpack_public_path__ + "static/media/directionRed.438ddb221a6e3805c933c2a8c366e8e6.svg";
export { ForwardRef as ReactComponent };